"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var RulerRole = {
  relatedConcepts: [],
  type: 'structure'
};
var _default = RulerRole;
exports.default = _default;